export const normalizeGeographyLabel = (value) => {
  const text = String(value || "").trim();
  const lowered = text.toLowerCase();

  if (["nec/ not mentioned", "nec/not mentioned", "nec / not mentioned", "not mentioned", "not available", "n/a"].includes(lowered)) {
    return "Not mentioned";
  }

  if (lowered.startsWith("pan india") || lowered.startsWith("pan-india")) {
    return "Pan-India";
  }

  return text;
};

export const formatFy = (value) => String(value || "").replace(/\s+/g, "").trim();

export const normalizeSectorLabel = (value) => {
  const text = String(value || "").trim();
  const lowered = text.toLowerCase();

  if (["nec/ not mentioned", "nec/not mentioned", "nec / not mentioned", "not mentioned", "not available", "n/a"].includes(lowered)) {
    return "Not mentioned";
  }

  return text;
};

export const normalizeImplementationModeLabel = (value) => {
  const text = String(value || "").trim();
  const lowered = text.toLowerCase();

  if (lowered === "other implementing agencies") {
    return "Other IA";
  }

  if (lowered === "by trusts/societies/ section 8 company set up by company itself") {
    return "Own NGO";
  }

  if (["nec/ not mentioned", "nec/not mentioned", "nec / not mentioned"].includes(lowered)) {
    return "Not available";
  }

  if (lowered === "directly by company") {
    return "Direct";
  }

  return text;
};

const sectorPalette = [
  "border-emerald-200 bg-emerald-50 text-emerald-800",
  "border-sky-200 bg-sky-50 text-sky-800",
  "border-amber-200 bg-amber-50 text-amber-800",
  "border-rose-200 bg-rose-50 text-rose-800",
  "border-violet-200 bg-violet-50 text-violet-800",
  "border-cyan-200 bg-cyan-50 text-cyan-800",
  "border-lime-200 bg-lime-50 text-lime-800",
  "border-orange-200 bg-orange-50 text-orange-800",
  "border-indigo-200 bg-indigo-50 text-indigo-800",
  "border-teal-200 bg-teal-50 text-teal-800",
];

export const getSectorChipClasses = (value) => {
  const label = normalizeSectorLabel(value).toLowerCase();
  let hash = 0;
  for (let index = 0; index < label.length; index += 1) {
    hash = (hash * 31 + label.charCodeAt(index)) % sectorPalette.length;
  }
  return sectorPalette[Math.abs(hash) % sectorPalette.length];
};